import React from "react";
import PostJobs from "../post-jobs/index";
function PostJob() {
  return (
    <div className="p-4">
      <PostJobs />
    </div>
  );
}

export default PostJob;
